import classNames from 'classnames';
import React from 'react';

import {Icon} from '@albert-io/atomic';
import type {IconColors} from '@albert-io/atomic/atoms/Icon/Icon.react';

interface Props {
  backgroundColorClass: 'background-bold' | 'background-brand-subtle-hover';
  iconColor: Extract<IconColors, 'brand' | 'tertiary'>;
}

export default function AssignmentIcon({backgroundColorClass, iconColor}: Props) {
  return (
    <div
      className={classNames(
        'flex h-x5 w-x5 items-center justify-center rounded-full p-x1',
        backgroundColorClass
      )}
    >
      <Icon color={iconColor} icon={['fal', 'file-alt']} />
    </div>
  );
}
